export const FLOATING_SIDEBAR_TOUR_ID = 'floating-sidebar';
export const RESOLVABLE_COMMENTS_TOUR_ID = 'resolvable-comments';